import { SendOccupationReportReminderApiPayload } from '@omecare/utils';
import { useMutation } from '@tanstack/react-query';
import httpService from '../../utils/http.service';

export function useSendOccupationReportReminder() {
  return useMutation({
    mutationFn: (payload: SendOccupationReportReminderApiPayload) =>
      httpService.offices.sendOccupationReportReminder(payload),
  });
}
